import styled from 'styled-components';
import { Icon, IconProps } from '@iconify/react';
import { BodyText, FlexRow, SvgIcon } from '@make-software/cspr-design';
import React from 'react';

export const BoldText = styled(BodyText)(({ theme }) =>
  theme.withMedia({
    fontWeight: '600'
  })
);

export const StyledActionIcon = styled(Icon)<IconProps>(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer',
    color: 'darkGray',
    padding: '0 8px',
    width: '24px',
    height: '24px'
  })
);

export const StyledActionIconEdit = (props: Omit<IconProps, 'icon'>) => (
  // @ts-ignore
  <StyledActionIcon icon="ri:pencil-fill" {...props} />
);

export const StyledActionIconView = (props: Omit<IconProps, 'icon'>) => (
  // @ts-ignore
  <StyledActionIcon icon="ri:eye-fill" {...props} />
);

export const StyledStatusDotGreen = styled.div(({ theme }) =>
  theme.withMedia({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#31DE91',
    margin: '8px 4px'
  })
);

export const StyledStatusDotRed = styled.div(({ theme }) =>
  theme.withMedia({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#E6332A',
    margin: '8px 4px'
  })
);

export const StyledStatusElement = ({
  name,
  isActive,
  regularText
}: {
  name: string;
  isActive: boolean;
  regularText?: boolean;
}) => (
  <FlexRow>
    {isActive ? <StyledStatusDotGreen /> : <StyledStatusDotRed />}
    {regularText ? (
      <BodyText size={3} scale={'sm'}>
        {name}
      </BodyText>
    ) : (
      <BoldText size={4} scale={'xs'}>
        {name}
      </BoldText>
    )}
  </FlexRow>
);
